module.exports = __webpack_public_path__ + "static/process5-8201874a268a0b5b791875d096df6bfb.png";